import { Component, Input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'fdx-demo-avatar',
    templateUrl: './demo-avatar.component.html',
    styleUrls: ['../user-avatar.scss', './demo-avatar.component.scss'],
    imports: [
        FaIconComponent
    ],
    standalone: true
})
export class DemoAvatarComponent {
    @Input() hasNotifications: boolean = false;
}
